import { type FC } from 'react';
import { Transfer } from 'antd';

export type TransferSuburbItem = {
  key: string;
  title: string;
};

type Props = Readonly<{
  dataSource: TransferSuburbItem[];
  targetKeys: string[];
  onChange: (nextTargetKeys: string[]) => void;
  isLoading?: boolean;
}>;

export const TechnicianServiceAreaTransfer: FC<Props> = ({ dataSource, targetKeys, onChange, isLoading }) => (
  <Transfer<TransferSuburbItem>
    dataSource={dataSource}
    targetKeys={targetKeys}
    onChange={(nextTargetKeys) => onChange(nextTargetKeys as string[])}
    render={(item) => item.title}
    titles={['Selected Suburbs', 'Unallocated Suburbs']}
    showSearch={{ placeholder: 'Search' }}
    filterOption={(inputValue, item) => item.title.toLowerCase().includes(inputValue.toLowerCase())}
    listStyle={{ width: 290, height: 625 }}
    disabled={isLoading}
  />
);
